import { render, staticRenderFns } from "./ItsColdStorageFeeDetail.vue?vue&type=template&id=bba47790&scoped=true&"
import script from "./ItsColdStorageFeeDetail.vue?vue&type=script&lang=js&"
export * from "./ItsColdStorageFeeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba47790",
  null
  
)

export default component.exports